import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import NotFoundImage from '@/shared/assets/not-found.svg';
import { ROUTES_PATH } from '@/shared/constants/routes';
import { Button } from '@/shared/ui/lib/Button';
import { CustomTypography } from '@/shared/ui/Typography';

import { StyledBox, StyledOops, StyledText } from './styles';

export const PaymentErrorPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleBackToChannels = () => {
    navigate(`/${ROUTES_PATH.MAIN.CHANNELS}`);
  };

  return (
    <StyledBox>
      <StyledText>
        <StyledOops>{t('billing:paymentErrorPage.title')}</StyledOops>
        <CustomTypography sx={{ fontSize: '18px' }}>
          {t('billing:paymentErrorPage.description')}
        </CustomTypography>

        <div>
          <Button
            color="primary"
            variant="contained"
            size="medium"
            onClick={handleBackToChannels}
            sx={{ marginRight: '16px' }}
          >
            {t('billing:paymentErrorPage.backToChannels')}
          </Button>
        </div>
      </StyledText>

      <NotFoundImage />
    </StyledBox>
  );
};
